import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/AuthContext";

// The service desk follows the login's "Use service desk" permission
// (Super Admin > Roles & access), as returned by /auth/me.
export function canAccessDesk(me) {
  return me?.role === "master" || (me?.permissions || []).includes("advisors_desk");
}

export function RequireDeskAccess({ children }) {
  const { me, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="animate-spin text-slate-400" size={24} />
      </div>
    );
  }

  if (!canAccessDesk(me)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
